var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAudioSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.18c0-1.58 1.29-2.87 2.87-2.87s2.87 1.29 2.87 2.87-1.29 2.87-2.87 2.87-2.87-1.29-2.87-2.87zm1.5.01c0 .75.61 1.37 1.37 1.37.75 0 1.37-.61 1.37-1.37 0-.76-.62-1.37-1.37-1.37-.75 0-1.37.61-1.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.99 15.18V7.77c0-.41.34-.75.75-.75s.75.34.75.75v7.41a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.87 11.32-2.34-.78c-.88-.29-1.54-1.21-1.54-2.14v-.62c0-.63.26-1.18.72-1.51.46-.33 1.06-.41 1.66-.21l2.34.78c.88.29 1.54 1.21 1.54 2.14v.62c0 .63-.26 1.18-.72 1.51-.29.21-.64.32-1.01.32-.21 0-.43-.04-.65-.11zm-2.29-3.84c-.06.04-.1.15-.1.29v.62c0 .28.26.63.52.72l2.34.78c.13.04.25.04.31 0s.1-.15.1-.29v-.62c0-.28-.26-.63-.52-.72l-2.34-.78a.615.615 0 0 0-.18-.03c-.05 0-.1.01-.13.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAudioSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-audio-square.1d8d2bfde3853b27275feb851ec573e5.svg";
export { ForwardRef as ReactComponent };